import React from "react";
import { useLocation } from "react-router-dom";

// Shows the result of the email verification link (the backend redirects
// to the login page with ?verified=1 | expired | invalid)
const MESSAGES = {
  "1": { type: "success", text: "Your email has been verified. You can now log in." },
  expired: { type: "error", text: "This verification link has expired. Log in to request a new one." },
  invalid: { type: "error", text: "This verification link is not valid. Log in to request a new one." },
};

const VerifiedEmailNotice = () => {
  const status = new URLSearchParams(useLocation().search).get("verified");
  const message = MESSAGES[status];
  if (!message) return null;

  return (
    <p
      className={`mx-8 mt-3 px-4 py-2 rounded-lg text-sm ${
        message.type === "success" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-600"
      }`}
    >
      {message.text}
    </p>
  );
};

export default VerifiedEmailNotice;
